import { Box, Stack, useMediaQuery } from "@mui/material";
import { GradientBgAtom } from "../atoms/gradient-bg-atom";
import { LogoAtom } from "../atoms/logo-atom";
import { CTAMolecule } from "../molecules/CTA-molecule";
import { ModelsMolecule } from "../molecules/models-molecule";
import { RegisterButtonAtom } from "../atoms/register-button-atom";
import { theme } from "../styles/mui-theme";
import { redirectionFn } from "../services/redirectionFn";
import { BottomShadowAtom } from "../atoms/bottom-shadow-atom";

export const LandingOrganism = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      sx={{
        position: "relative",
        zIndex: 4,
        backgroundColor: "#141414",
        width: "100%",
        height: "100dvh",
        justifyContent: isMobile ? "center" : "space-between",
        alignItems: "center",
        padding: isMobile ? "0" : "0 0 0 100px",
        overflow: "hidden",
        boxSizing: "border-box",
        "&::before": isMobile && {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "calc(100vh - 55px)",
          background:
            "linear-gradient(180deg, #141414 3%, rgba(20, 20, 20, 0.00) 100%)",
          zIndex: 5,
          pointerEvents: "none",
        },
      }}
    >
      {isMobile && <GradientBgAtom />}
      <Stack
        justifyContent={"space-between"}
        width={"100%"}
        height={"100%"}
        paddingTop={"75px"}
      >
        <LogoAtom />
        <CTAMolecule />
        <Box />
      </Stack>
      <ModelsMolecule />
      {isMobile && <BottomShadowAtom />}
      {isMobile && (
        <RegisterButtonAtom onRegisterClick={() => redirectionFn()} />
      )}
    </Stack>
  );
};
